import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = false;

export const snackBarOpenSlice = createSlice({
  name: "snackBarOpen",
  initialState,
  reducers: {
    setSnackBarOpen: (state, action: PayloadAction<boolean>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { setSnackBarOpen } = snackBarOpenSlice.actions;

export default snackBarOpenSlice.reducer;
